<template>
  <div class="profile">
    <div class="card">
      <div class="flex justify-between">
        <div>
          <p class="text-deepBlue font-semibold">Basic Information</p>
        </div>
        <div>
          <img src="@/assets/images/icons/info.svg" alt="information icon" />
        </div>
      </div>

      <div class="flex gap-4 items-center">
        <image-uploader @input="handleImageUpload($event)" @remove-image="removeImage"
          :isUploadingImage="isUploadingImage" />
        <!-- <img src="@/assets/images/profile-img.png" alt="Profile image" /> -->
        <p>Upload Photo</p>
      </div>

      <div class="basic-info-form container-fluid">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Name:</label>
            <input type="text" class="input" placeholder="Enter customer name" v-model="contact.name" />
          </div>

          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Type: CCC</label>
            <el-select v-model="contact.kind" placeholder="Individual/Organization">
              <el-option v-for="kind in customerKinds" :key="kind" :label="kind" :value="kind" @change="getType(value)">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">MuleEx ID:</label>
            <input type="text" class="input" placeholder="" :disabled="true" v-model="contact.code" />
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Industry Sector:</label>
            <el-select v-model="contact.industrySector" placeholder="Select">
              <el-option v-for="industry in industries" :key="industry" :label="industry" :value="industry">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Profile Information:</label>
            <input type="text" class="input" placeholder="Select" v-model="contact.profile" />
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Loyalty Scheme:
              <span class="text-xs underline cursor-pointer" @click="isLoyaltySchemeModal = true">Set Up a Loyalty
                Scheme</span></label>
            <el-select v-model="contact.loyaltySchemeId" placeholder="Select">
              <el-option v-for="scheme in loyaltySchemes" :key="scheme.id" :label="scheme.loyaltyCategory"
                :value="scheme.id">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Price Reference:</label>
            <el-select v-model="contact.contactCategory" placeholder="Select">
              <el-option v-for="preference in pricePreferences" :key="preference" :label="preference"
                :value="preference">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Lead Status:</label>
            <el-select v-model="contact.leadStatus" placeholder="Select">
              <el-option v-for="status in leadStatuses" :key="status" :label="status" :value="status">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4" v-if="contact.kind == 'individual'">
            <label class="label">Gender:</label>
            <el-select v-model="contact.gender" placeholder="Select">
              <el-option v-for="gender in genders" :key="gender" :label="gender" :value="gender">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4" v-if="contact.kind == 'individual'">
            <label class="label">Birthday:</label>
            <el-date-picker v-model="contact.birthday" type="date" placeholder="Pick a day">
            </el-date-picker>
          </div>
        </div>
      </div>

      <div class="billing-address">
        <div class="pt-5 pb-1">
          <p class="text-deepBlue font-semibold">Contact Information</p>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4" v-if="contact.kind == 'organization'">
              <label class="label">Contact Person:</label>
              <input type="text" class="input" placeholder="Enter contact person" v-model="contact.contactPerson" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">Phone Number:</label>
              <input type="text" class="input" placeholder="Enter phone number" v-model="contact.phone" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">Email:</label>
              <!-- <input
                type="text"
                class="input"
                placeholder="Enter email address"
                v-model="contact.email"
              /> -->
              <email-input v-model="contact.email" />
            </div>
          </div>
        </div>
      </div>

      <div class="billing-address">
        <div class="pt-5 pb-2">
          <p class="text-deepBlue font-semibold">Billing Address</p>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">Country:</label>
              <!-- <country-dropdown @change="contact.country = $event" /> -->
              <el-select v-model="contact.country" placeholder="Select country">
                <el-option v-for="country in countries" :key="country" :label="country" :value="country">
                </el-option>
              </el-select>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">Address:</label>
              <input type="text" class="input" placeholder="Enter address" v-model="contact.address" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">State:</label>
              <!-- <state-dropdown
                @change="contact.state = $event"
                @save-cities="cities = $event"
              /> -->
              <el-select v-model="contact.state" placeholder="Select state" @change="getCitiesInState(contact.state)">
                <el-option v-for="state in states" :key="state.id" :label="state.name" :value="state.name">
                </el-option>
              </el-select>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">City:</label>
              <!-- <city-dropdown :cities="cities" @change="contact.city = $event" /> -->
              <el-select v-model="contact.city" placeholder="Select city">
                <el-option v-for="city in cities" :key="city" :label="city" :value="city">
                </el-option>
              </el-select>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">Zip/Postal Code:</label>
              <input type="text" class="input" placeholder="Enter zip code" v-model="contact.zipCode" />
            </div>
          </div>
        </div>
      </div>

      <div class="shipping-address">
        <div class="pt-4 pb-2">
          <p class="text-deepBlue font-semibold">Delivery Address(es)</p>
        </div>
        <div class="container-fluid" v-if="contact.deliveryAddress">
          <div class="row" v-for="(address, index) in firstDeliveryAddress" :key="index">
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">Country:</label>
              <!-- <country-dropdown @change="customer.country = $event" /> -->
              <el-select v-model="contact.country" placeholder="Select country">
                <el-option v-for="country in countries" :key="country" :label="country" :value="country">
                </el-option>
              </el-select>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">Address:</label>
              <input type="text" class="input" placeholder="Enter address" v-model="contact.address" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">State:</label>

              <el-select v-model="contact.state" placeholder="Select state" @change="getCitiesInState(address.state)">
                <el-option v-for="state in states" :key="state.name" :label="state.name" :value="state.name">
                </el-option>
              </el-select>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">City:</label>
              <el-select v-model="contact.city" placeholder="Select city">
                <el-option v-for="city in cities" :key="city" :label="city" :value="city">
                </el-option>
              </el-select>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">Zip/Postal Code:</label>
              <input type="text" class="input" placeholder="Enter zip code" v-model="contact.zipCode" />
            </div>
          </div>
        </div>
        <div v-else class="py-4">
          <p class="text-sm">
            This contact has no shipping address registered!
          </p>
        </div>
        <p class="font-semibold text-deepBlue cursor-pointer py-2" @click="$router.push({ name: 'DeliveryAddresses' })">
          {{
              contact.deliveryAddress
                ? " View All Delivery Addresses"
                : "Create shipping address(es)"
          }}
        </p>
      </div>

      <div class="actions flex justify-between py-12">
        <div>
          <primary-button buttonText="Apply Changes" :loading="loading" @click="updateContact" />
        </div>
      </div>
    </div>

    <loyalty-scheme-form :show-modal="isLoyaltySchemeModal" @close-modal="isLoyaltySchemeModal = false"
      @scheme-created="getAllLoyaltySchemes" />
  </div>
</template>

<script>
import LoyaltySchemeForm from "../../CustomerRegistration/Modals/CreateLoyaltyScheme";
import ImageUploader from "@/components/3pl/Users/ImageUploader";

import { industries } from "@/utilities/globalVariables.js";

export default {
  name: "profile",
  components: {
    LoyaltySchemeForm,
    ImageUploader
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      customerKinds: ["individual", "organization"],
      genders: ["Female", "Male", "Others"],
      countries: ["Nigeria"],
      industries: industries,
      leadStatuses: ["new", "qualified", "unqualified"],
      loyaltySchemes: [],
      pricePreferences: ["retail", "wholesale"],
      cities: [],
      states: [],
      loading: false,
      isLoyaltySchemeModal: false,
      firstDeliveryAddress: [],
      citiesInDeliveryAddressState: [],
      isUploadingImage: false,
    };
  },
  watch: {
    contact() {
      if (this.contact.deliveryAddress) {
        this.firstDeliveryAddress.push(this.contact.deliveryAddress[0]);
        console.log(this.firstDeliveryAddress);
      }
      this.getCitiesInState(this.contact.state);
    },
  },
  mounted() {
    this.getAllLoyaltySchemes();
    // this.setShippingAddress();
    this.getAllStatesAndCities();
  },
  methods: {
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.contact.imageurl = response;
        // console.log("imageurl", response);
        this.isUploadingImage = false;
        this.generateToast("Image uploaded", "success");
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.contact.imageurl = null;
    },
    async updateContact() {
      this.loading = true;

      let orgId = localStorage.getItem("organizationId");
      const payload = {
        userInfo: {
          orgId: orgId,
          outletId: null,
          creatorId: orgId,
        },
        payload: {
          ...this.contact,
        },
      };
      try {
        const response = await this.$_updateContact(this.contact.id, payload);
        this.logResponse(response);
        this.generateToast("Contact updated successfully!", "success");
        this.$emit("contact-updated");
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async getAllLoyaltySchemes() {
      try {
        const response = await this.$_getAllLoyaltySchemes();
        this.logResponse(response);
        this.loyaltySchemes = response.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllStates() {
      try {
        let response = await this.$_getAllStates();
        console.log(response);
        this.states = response.data.findState;
        // this.getCitiesInState();
      } catch (error) {
        this.handleError(error);
      }
    },
    getCitiesInState(state) {
      // let formattedStateName = state
      //   .replace(/\s/g, "")
      //   .replace("State", "")
      //   .toLowerCase();
      this.getCities(state);
    },
    async getCities(stateName) {
      this.cities = [];
      try {
        // let response = await this.$_getCities(stateName);
        // this.cities = response.data.allCities;
        this.cities = [];
        if (stateName?.length > 0) {
          this.cities = [...this.states.find(state => state.name == stateName).cities]
        }
        this.$emit("save-cities", this.cities);
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped>
.label {
  margin-top: 1rem;
}

/* input {
  height: 2.2rem;
  background: #fbfcfe;
  border: 0.5px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 3px;
} */
</style>
